import i18next from 'i18next';

/**
 * Publications data
 */
const publications = [
  {
    title: "Arctic-TILT. Business Document Understanding at Sub-Billion Scale",
    authors: "Ł Borchmann, M Pietruszka, W Jaśkowski, D Jurkiewicz, P Halama, P Józiak, Ł Garncarek, P Liskowski, K Szyndler, A Gretkowski, J Ołtusek, G Nowakowska, A Zawłocki, Ł Duhr, P Dyda, M Turski",
    citation: "Proceedings of the 63rd Annual Meeting of the Association for Computational Linguistics",
    year: "2025",
    citations: 0,
    link: "https://aclanthology.org/2025.acl-industry.20/",
    doi: "10.18653/v1/2025.acl-industry.20",
    dateISO: "2025-07-27",
    abstract: "The vast portion of workloads employing LLMs involves answering questions grounded on PDF or scan content. We introduce the Arctic-TILT achieving accuracy on par with models 1000× its size on these use cases. It can be fine-tuned and deployed on a single 24GB GPU, lowering operational costs while processing Visually Rich Documents with up to 400k tokens. The model establishes state-of-the-art results on seven diverse Document Understanding benchmarks, as well as provides reliable confidence scores and quick inference, which are essential for processing files in large-scale or time-sensitive enterprise environments."
  },
  {
    title: "STable: Table Generation Framework for Encoder-Decoder Models",
    authors: "M Pietruszka, M Turski, Ł Borchmann, T Dwojak, G Nowakowska, K Szyndler, D Jurkiewicz, Ł Garncarek",
    citation: "Proceedings of the 18th Conference of the European Chapter of the Association for Computational Linguistics",
    year: "2024",
    citations: 0,
    link: "https://aclanthology.org/2024.eacl-long.151/",
    doi: "10.18653/v1/2024.eacl-long.151",
    dateISO: "2024-03-18",
    abstract: "The output structure of database-like tables, consisting of values structured in horizontal rows and vertical columns identifiable by name, can cover a wide range of NLP tasks. Following this constatation, we propose a framework for text-to-table neural models applicable to problems such as extraction of line items, joint entity and relation extraction, or knowledge base population. The permutation-based decoder of our proposal is a generalized sequential method that comprehends information from all cells in the table. The training maximizes the expected log-likelihood for a table's content across all random permutations of the factorization order. During the content inference, we exploit the model's ability to generate cells in any order by searching over possible orderings to maximize the model's confidence and avoid substantial error accumulation, which other sequential models are prone to. Experiments demonstrate a high practical value of the framework, which establishes state-of-the-art results on several challenging datasets, outperforming previous solutions by up to 15%."
  },
  {
    title: "Exploring the Use of Foundation Models for Named Entity Recognition and Lemmatization Tasks in Slavic Languages",
    authors: "G Pałka, A Nowakowski",
    citation: "Proceedings of the 9th Workshop on Slavic Natural Language Processing 2023 (SlavicNLP 2023)",
    year: "2023",
    citations: 0,
    link: "https://aclanthology.org/2023.bsnlp-1.19/",
    doi: "10.18653/v1/2023.bsnlp-1.19",
    dateISO: "2023-05-06",
    abstract: "This paper describes Adam Mickiewicz University's (AMU) solution for the 4th Shared Task on SlavNER. The task involves the identification, categorization, and lemmatization of named entities in Slavic languages. Our approach involved exploring the use of foundation models for these tasks. In particular, we used models based on the popular BERT and T5 model architectures. Additionally, we used external datasets to further improve the quality of our models. Our solution obtained promising results, achieving high metrics scores in both tasks. We describe our approach and the results of our experiments in detail, showing that the method is effective for NER and lemmatization in Slavic languages. Additionally, our models for lemmatization will be available at: https://huggingface.co/amu-cai."
  },
  {
    title: "Adam Mickiewicz University at WMT 2022: NER-Assisted and Quality-Aware Neural Machine Translation",
    authors: "A Nowakowski, G Pałka, K Guttmann, M Pokrywka",
    citation: "Proceedings of the Seventh Conference on Machine Translation (WMT)",
    year: "2022",
    citations: 0,
    link: "https://aclanthology.org/2022.wmt-1.26/",
    dateISO: "2022-12-07",
    abstract: "This paper presents Adam Mickiewicz University's (AMU) submissions to the constrained track of the WMT 2022 General MT Task. We participated in the Ukrainian ↔ Czech translation directions. The systems are a weighted ensemble of four models based on the Transformer (big) architecture. The models use source factors to utilize the information about named entities present in the input. Each of the models in the ensemble was trained using only the data provided by the shared task organizers. A noisy back-translation technique was used to augment the training corpora. One of the models in the ensemble is a document-level model, trained on parallel and synthetic longer sequences. During the sentence-level decoding process, the ensemble generated the n-best list. The n-best list was merged with the n-best list generated by a single document-level model which translated multiple sentences at a time. Finally, existing quality estimation models and minimum Bayes risk decoding were used to rerank the n-best list so that the best hypothesis was chosen according to the COMET evaluation metric. According to the automatic evaluation results, our systems rank first in both translation directions."
  },
  {
    title: "Going Full-TILT Boogie on Document Understanding with Text-Image-Layout Transformer",
    authors: "R Powalski, Ł Borchmann, D Jurkiewicz, T Dwojak, M Pietruszka, G Pałka",
    citation: "Document Analysis and Recognition – ICDAR 2021",
    year: "2021",
    citations: 0,
    link: "https://link.springer.com/chapter/10.1007/978-3-030-86331-9_47",
    doi: "10.1007/978-3-030-86331-9_47",
    dateISO: "2021-09-02",
    abstract: "We address the challenging problem of Natural Language Comprehension beyond plain-text documents by introducing the TILT neural network architecture which simultaneously learns layout information, visual features, and textual semantics. Contrary to previous approaches, we rely on a decoder capable of unifying a variety of problems involving natural language. The layout is represented as an attention bias and complemented with contextualized visual information, while the core of our model is a pretrained encoder-decoder Transformer. Our novel approach achieves state-of-the-art results in extracting information from documents and answering questions which demand layout understanding (DocVQA, CORD, SROIE). At the same time, we simplify the process by employing an end-to-end model."
  },
  {
    title: "Contract discovery: Dataset and a few-shot semantic retrieval challenge with competitive baselines",
    authors: "Ł Borchmann, D Wiśniewski, A Gretkowski, I Kosmala, D Jurkiewicz, G Pałka",
    citation: "Findings of the Association for Computational Linguistics: EMNLP 2020",
    year: "2020",
    citations: 0,
    link: "https://aclanthology.org/2020.findings-emnlp.380/",
    doi: "10.18653/v1/2020.findings-emnlp.380",
    dateISO: "2020-11-16",
    abstract: "We propose a new shared task of semantic retrieval from legal texts, in which a so-called contract discovery is to be performed – where legal clauses are extracted from documents, given a few examples of similar clauses from other legal acts. The task differs substantially from conventional NLI and shared tasks on legal information extraction (e.g., one has to identify text span instead of a single document, page, or paragraph). The specification of the proposed task is followed by an evaluation of multiple solutions within the unified framework proposed for this branch of methods. It is shown that state-of-the-art pretrained encoders fail to provide satisfactory results on the task proposed. In contrast, Language Model-based solutions perform better, especially when unsupervised fine-tuning is applied. Besides the ablation studies, we addressed questions regarding detection accuracy for relevant text fragments depending on the number of examples available. In addition to the dataset and reference results, LMs specialized in the legal domain were made publicly available."
  }
];

/**
 * Create HTML for a publication item
 * @param {Object} publication - Publication data
 * @returns {string} - HTML string for publication item
 */
function formatPublicationDate(publication) {
  if (!publication.dateISO) return publication.date || '';
  try {
    const lang = i18next?.language || 'en';
    const formatter = new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'long', day: 'numeric' });
    return formatter.format(new Date(publication.dateISO));
  } catch (e) {
    return publication.date || '';
  }
}

function createPublicationCard(publication) {
  const hasAbstract = publication.abstract && publication.abstract.trim() !== '';
  
  return `
    <div class="publication-item">
      <h4 class="publication-title">
        <a href="${publication.link}" target="_blank" rel="noopener noreferrer">${publication.title}</a>
      </h4>
      <div class="publication-meta">
        <div class="publication-line pub-authors">• ${i18next.t('publications.labels.authors')} ${publication.authors}</div>
        <div class="publication-line pub-venue">• ${i18next.t('publications.labels.venue')} ${publication.citation}</div>
        ${publication.doi
          ? `<div class=\"publication-line pub-doi\">• ${i18next.t('publications.labels.doi')} <a href=\"https://doi.org/${publication.doi}\" target=\"_blank\" rel=\"noopener noreferrer\">${publication.doi}</a></div>`
          : `<div class=\"publication-line pub-doi\">• ${i18next.t('publications.labels.url')} <a href=\"${publication.link}\" target=\"_blank\" rel=\"noopener noreferrer\">${publication.link}</a></div>`}
        <div class="publication-line pub-date">• ${i18next.t('publications.labels.date')} ${formatPublicationDate(publication)}</div>
      </div>
      ${hasAbstract ? 
        `<div class="publication-abstract-container">
          <button class="abstract-toggle" aria-expanded="false">${i18next.t('publications.labels.showAbstract')}</button>
          <div class="publication-abstract" hidden>${publication.abstract}</div>
         </div>` 
        : ''}
    </div>
  `;
}

/**
 * Create HTML for year section
 * @param {string} year - Year
 * @param {Array} yearPublications - Publications for that year
 * @returns {string} - HTML string for year section
 */
function createYearSection(year, yearPublications) {
  // Sort publications by dateISO (most recent first)
  const sortedYearPublications = [...yearPublications].sort((a, b) => {
    if (a.dateISO && b.dateISO) {
      return new Date(b.dateISO) - new Date(a.dateISO);
    }
    return 0;
  });
  
  const publicationsHTML = sortedYearPublications
    .map(pub => createPublicationCard(pub))
    .join('');
    
  return `
    <div class="publications-year">
      <h3 class="year-heading">${year}</h3>
      <div class="year-publications">
        ${publicationsHTML}
      </div>
    </div>
  `;
}

/**
 * Setup abstract toggle buttons
 */
function setupAbstractToggles() {
  const toggleButtons = document.querySelectorAll('.abstract-toggle');
  
  toggleButtons.forEach(button => {
        button.addEventListener('click', () => {
      const abstractElement = button.nextElementSibling;
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      
      // Toggle the abstract visibility
      if (isExpanded) {
        abstractElement.setAttribute('hidden', '');
        button.setAttribute('aria-expanded', 'false');
            button.textContent = i18next.t('publications.labels.showAbstract');
      } else {
        abstractElement.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
            button.textContent = i18next.t('publications.labels.hideAbstract');
      }
    });
  });
}

/**
 * Load publications into the DOM
 */
export function loadPublications() {
  const publicationsContainer = document.querySelector('.publications');
  if (!publicationsContainer) return;
  
  // Group publications by year
  const publicationsByYear = {};
  
  publications.forEach(pub => {
    if (!publicationsByYear[pub.year]) {
      publicationsByYear[pub.year] = [];
    }
    publicationsByYear[pub.year].push(pub);
  });
  
  // Get years and sort them in descending order
  const years = Object.keys(publicationsByYear).sort((a, b) => b - a);
  
  // Generate HTML for all years
  const publicationsHTML = years
    .map(year => createYearSection(year, publicationsByYear[year]))
    .join('');
  
  // Insert the HTML into the container
  publicationsContainer.innerHTML = publicationsHTML;
  
  // Setup toggle buttons
  setupAbstractToggles();
} 

// Re-render publications on language change to localize dates
let publicationsLanguageListenerAttached = false;
if (!publicationsLanguageListenerAttached && typeof i18next !== 'undefined' && i18next?.on) {
  i18next.on('languageChanged', () => {
    loadPublications();
  });
  publicationsLanguageListenerAttached = true;
}